/** Filter keys for the Activity Log filters (FilterDefinition.id / FilterItem.key). */
export const FILTER_KEY = {
  people: 'people',
  brains: 'brains',
  collections: 'collections',
  desks: 'desks',
  connections: 'connections',
} as const;

export type FilterKey = (typeof FILTER_KEY)[keyof typeof FILTER_KEY];

/**
 * Knowledge bases and Connections both filter the audit log's `target_ids`; this maps each
 * to the `target_types[]` value the backend uses to disambiguate them.
 */
export const TARGET_TYPE = {
  [FILTER_KEY.collections]: 'collections',
  [FILTER_KEY.connections]: 'integrations',
} as const;

/** Backend caps every `*_ids[]` param at 25 values; mirror that in the UI. */
export const MAX_FILTER_VALUES = 25;

/** localStorage / preferences keys for `useTableFilters`. */
export const ACTIVITY_LOG_FILTERS_STORAGE_KEY = 'activityLogFilters';
export const ACTIVITY_LOG_FILTERS_PREFERENCES_KEY = 'activity_logs';
